/**
 * @generated SignedSource<<2c6ead056a0932ea97b81a65f6b0dda4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraSprintState = "ACTIVE" | "CLOSED" | "FUTURE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type FirstGroupRow_GroupRow$data = {
  readonly fieldId: string | null | undefined;
  readonly fieldSetId?: string | null | undefined;
  readonly fieldType: string | null | undefined;
  readonly fieldValue: {
    readonly __typename: string;
    readonly goal?: {
      readonly id: string;
    };
    readonly group?: {
      readonly groupId: string;
      readonly id: string;
      readonly name: string;
    };
    readonly jqlTerm?: string;
    readonly label?: {
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly number?: number | null | undefined;
    readonly option?: {
      readonly color: {
        readonly colorKey: string | null | undefined;
        readonly id: string | null | undefined;
      } | null | undefined;
      readonly id: string;
      readonly optionId: string;
      readonly value: string | null | undefined;
    } | null | undefined;
    readonly priority?: {
      readonly iconUrl: AGG$URL | null | undefined;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly priorityId: string;
    };
    readonly sprint?: {
      readonly endDate: AGG$DateTime | null | undefined;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly sprintId: string;
      readonly state: JiraSprintState | null | undefined;
    };
    readonly status?: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly statusCategory: {
        readonly id: string;
        readonly statusCategoryId: string;
      } | null | undefined;
    } | null | undefined;
    readonly user?: {
      readonly accountId: string;
      readonly id: string;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
    readonly version?: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly versionId: string;
    } | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly jql: string;
  readonly " $fragmentSpreads": FragmentRefs<"GroupHeader">;
  readonly " $fragmentType": "FirstGroupRow_GroupRow";
};
export type FirstGroupRow_GroupRow$key = {
  readonly " $data"?: FirstGroupRow_GroupRow$data;
  readonly " $fragmentSpreads": FragmentRefs<"FirstGroupRow_GroupRow">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "FirstGroupRow_GroupRow",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "jql"
      },
      "action": "THROW",
      "path": "jql"
    },
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "fieldType"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "fieldSetId"
        }
      ]
    },
    {
      "kind": "LinkedField",
      "name": "fieldValue",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "jqlTerm"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "concreteType": "JiraLabel",
                  "kind": "LinkedField",
                  "name": "label",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/)
                  ]
                }
              ],
              "type": "JiraJqlLabelFieldValue"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "concreteType": "JiraGroup",
                  "kind": "LinkedField",
                  "name": "group",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "groupId"
                    },
                    (v1/*: any*/)
                  ]
                }
              ],
              "type": "JiraJqlGroupFieldValue"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "concreteType": "JiraVersion",
                  "kind": "LinkedField",
                  "name": "version",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "versionId"
                    },
                    (v1/*: any*/)
                  ]
                }
              ],
              "type": "JiraJqlVersionFieldValue"
            }
          ]
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraPriority",
              "kind": "LinkedField",
              "name": "priority",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "priorityId"
                },
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "iconUrl"
                }
              ]
            }
          ],
          "type": "JiraJqlPriorityFieldValue"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "accountId"
                },
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "picture"
                }
              ]
            }
          ],
          "type": "JiraJqlUserFieldValue"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraStatus",
              "kind": "LinkedField",
              "name": "status",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "concreteType": "JiraStatusCategory",
                  "kind": "LinkedField",
                  "name": "statusCategory",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "statusCategoryId"
                    }
                  ]
                }
              ]
            }
          ],
          "type": "JiraJqlStatusFieldValue"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "number"
            }
          ],
          "type": "JiraJqlNumberFieldValue"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraOption",
              "kind": "LinkedField",
              "name": "option",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "optionId"
                },
                {
                  "kind": "ScalarField",
                  "name": "value"
                },
                {
                  "concreteType": "JiraColor",
                  "kind": "LinkedField",
                  "name": "color",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "colorKey"
                    },
                    (v0/*: any*/)
                  ]
                }
              ]
            }
          ],
          "type": "JiraJqlOptionFieldValue"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraSprint",
              "kind": "LinkedField",
              "name": "sprint",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "sprintId"
                },
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "state"
                },
                {
                  "kind": "ScalarField",
                  "name": "endDate"
                }
              ]
            }
          ],
          "type": "JiraJqlSprintFieldValue"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraGoal",
              "kind": "LinkedField",
              "name": "goal",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ]
            }
          ],
          "type": "JiraJqlGoalsFieldValue"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "GroupHeader"
    }
  ],
  "type": "JiraSpreadsheetGroup"
};
})();

(node as any).hash = "34b233d7624a5e5dd2a0810c27a25912";

export default node;
